import React from "react"
import Layout from "../components/layout"
import Babylonbutton from '../components/babylonbutton'
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />   
    <Babylonbutton />
  </Layout>
)

export default IndexPage
